export default __webpack_public_path__ + "static/icon-8-3-4f43c6527a3c6ff8d2f895f0c7172523.png";